import { useEffect, useState } from 'react';

import useApi from '@/hooks/useApi';
import useLaunchDarkly from '@/hooks/useLaunchDarkly';
import useProfile from '@/hooks/useProfile';

import * as taxonomiService from '@/services/requests/Taxonomy';
import { TCard } from '@/services/requests/Recommendation/types/template2';

import { getValue } from '@/helpers/GetValueHelper';

type TProps = {
  cards: TCard[];
};

export const useTaxonomy = ({ cards }: TProps) => {
  const { Api } = useApi();
  const { taxonomyURL } = useLaunchDarkly();
  const profile = useProfile();

  const [images, setImages] = useState<any[]>(cards.map(() => ''));
  const [countImagesLoaded, setCountImagesLoaded] = useState(0);

  const getImage = (arrImages: any[]) => {
    let result = '';
    if (arrImages) {
      const imagesListFromTaxonomy = getValue(
        arrImages,
        '[0].imageList',
        [],
      ) as {
        imageWidth: string;
        imageFile: string;
      }[];

      if (imagesListFromTaxonomy) {
        const newImageWith264Width = imagesListFromTaxonomy.find(
          item => item.imageWidth === '264',
        );
        if (newImageWith264Width) {
          console.log('smilesBaseUrl: ', profile.profile.smilesBaseUrl);
          const pat = /^https?:\/\/|^\/\//i;
          result = pat.test(newImageWith264Width.imageFile)
            ? newImageWith264Width.imageFile
            : profile.profile.smilesBaseUrl + newImageWith264Width.imageFile;
        }
      }
    }
    return result;
  };

  const changeImages = (promises: any[], startIndex = 0) => {
    const newImages = [...images] as any[];

    promises.forEach(({ status, value }, index) => {
      const newIndex = index + startIndex;

      if (status === 'fulfilled') {
        if (Array.isArray(value)) {
          const newImage = getImage(value);
          newImages[newIndex] = newImage || cards[newIndex].image.image.url;
        } else {
          newImages[newIndex] = value;
        }
      } else {
        newImages[newIndex] = cards[newIndex].image.image.url;
      }
    });

    setImages(newImages);
  };

  const fetchImages = async (start: number, end: number) => {
    const promises = [] as any[];

    cards.slice(start, end).forEach(item => {
      if (!item.image.image.imageTag) {
        const imageFromRecommendation =
          item.image.image.url || item.image.image.imageExternalUrl;
        promises.push(Promise.resolve(imageFromRecommendation));
      } else {
        promises.push(
          taxonomiService.getTaxonomyData(
            Api,
            [item.image.image.imageTag],
            taxonomyURL,
          ),
        );
      }
    });

    changeImages(await Promise.allSettled(promises), start);
  };

  useEffect(() => {
    fetchImages(0, 4);
  }, []);

  useEffect(() => {
    if (countImagesLoaded === 1 && cards.length > 4) {
      fetchImages(4, cards.length);
    }
    setCountImagesLoaded(prev => prev + 1);
  }, [images]);

  return {
    images,
    countImagesLoaded,
  };
};
